import { useUserSettings } from "@common/components/ProfileBadge/DrawerContent/SettingsContent";
import { useEffect } from "react";
import { GOOGLE_ANALYTICS_COOKIES } from "./const";
import { loadClarity, loadGTM } from "./utils";
import { useLocalStorage } from "@services/common/hooks/useLocalStorage";
import { GA_COOKIES_CLEARED } from "@common/constants";

export const useGoogleAnalytics = () => {
  const [{ areAnalyticsActive }] = useUserSettings();
  const [gaCookiesCleared, setGaCookiesCleared] =
    useLocalStorage<boolean>(GA_COOKIES_CLEARED);

  useEffect(() => {
    const CLARITY_ID = __symphony_env__.REACT_APP_CLARITY_ID;
    const GTM_ID = __symphony_env__.REACT_APP_GTM_ID;

    let headerScriptNode: HTMLScriptElement | null = null;
    let bodyScriptNode1: HTMLScriptElement | null = null;
    let bodyScriptNode2: HTMLScriptElement | null = null;

    if (areAnalyticsActive && CLARITY_ID && GTM_ID) {
      loadClarity(CLARITY_ID);
      loadGTM(GTM_ID);
      if (gaCookiesCleared) {
        setGaCookiesCleared(null);
      }
    }

    if (
      !areAnalyticsActive &&
      !gaCookiesCleared &&
      GOOGLE_ANALYTICS_COOKIES.some(({ name }) =>
        document.cookie
          .split(";")
          .some((pair) => pair.split("=")[0].trim() === name)
      )
    ) {
      const domain = window.location.hostname.includes(".")
        ? `.${window.location.hostname.split(".").slice(-2).join(".")}`
        : window.location.hostname;
      GOOGLE_ANALYTICS_COOKIES.forEach(
        ({ name }) =>
          (document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`)
      );
      setGaCookiesCleared(true);
      location.reload();
    }

    return () => {
      if (headerScriptNode) {
        document.head.removeChild(headerScriptNode);
      }

      if (bodyScriptNode1) {
        document.body.removeChild(bodyScriptNode1);
      }

      if (bodyScriptNode2) {
        document.body.removeChild(bodyScriptNode2);
      }
    };
  }, [areAnalyticsActive]);
};
